// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2L8g4","imageUploader":"EGiftCard_imageUploader__1hUOC"};